import { atom } from "recoil";

export const verificationRefetchState = atom({
    key: "verificationRefetchState",
    default: {
        refetchUserVerificationProfile: null,
        refetchUserVerificationFlows: null,
        refetchUserVerificationTiers: null,
        refetchUserVerificationHistories: null,
    },
});